import React, { useState } from "react";
import store from "store";
import { APIContext } from "./api";

const PROD_APPLICATION_ID = "0YIwhFZ6qTsz";
const DEV_APPLICATION_ID = "5robJaspFCxA";

export function getNovuApplicationId() {
	const isDevEnvironment =
		window.location.hostname.startsWith("dev.") ||
		window.location.hostname === "localhost";
	const isProductionVersion = import.meta.env.PROD;
	if (store.get("local_dev", false)) {
		return DEV_APPLICATION_ID;
	}
	if (isProductionVersion) {
		if (isDevEnvironment) {
			return DEV_APPLICATION_ID;
		}
		return PROD_APPLICATION_ID;
	}
	if (store.get("local_dev", false)) {
		return DEV_APPLICATION_ID;
	}
	return DEV_APPLICATION_ID;
}

export function useGetNovuHMAC(
	organizationId: string | null | undefined,
): string | null {
	const [hmac, setHmac] = useState<string | null>(null);
	const api = React.useContext(APIContext);
	React.useEffect(() => {
		if (organizationId) {
			api
				.get<string>(`/organizations/${organizationId}/notifications/getHMAC`)
				.then((response) => {
					setHmac(response.data);
				});
		}
	}, [api, organizationId]);
	return hmac;
}
